<template>
    <div>
        <div v-if="resultsTabs.length" class="s-statistics__results__tabs">
            <div v-for="tab in resultsTabs" :key="tab.id" class="s-statistics__results__tabs__item">
                <a
                    href="javascript:void(0)"
                    :class="['dotted-link', { active: tab.id === activeResultsTab }]"
                    @click="resultsTabClicked(tab.id)">
                    {{ tab.text }}
                </a>
            </div>
        </div>
        <div class="s-statistics__results__cont">
            <div class="s-statistics__table">
                <article class="b-article">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <span>
                                        <template v-if="activeResultsTab === 'cheques'">
                                            {{ appData.dictionary.tableCheques }}
                                        </template>
                                        <template v-if="activeResultsTab === 'unpaidBills'">
                                            {{ appData.dictionary.tableUnpaidBills }}
                                        </template>
                                    </span>
                                </th>
                                <th>
                                    <span>{{ appData.dictionary?.tablePieces }}</span>
                                </th>
                                <th>
                                    <span>{{ appData.dictionary?.tableAmounts }}</span>
                                </th>
                                <th class="green-bold">
                                    <span>{{ appData.dictionary?.tableCumulativeSumOfPieces }}</span>
                                </th>
                                <th class="green-bold">
                                    <span>{{ appData.dictionary?.tableCumulativeSumOfAmounts }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, row_i) in activeResults" :key="'row-' + row_i">
                                <td>
                                    <strong>{{ appData.dictionary?.months[row.month] }}</strong>
                                </td>
                                <td>
                                    {{ row.pieces?.toLocaleString(appData.configuration.locale) }}
                                </td>
                                <td>
                                    {{ row.amounts?.toLocaleString(appData.configuration.locale) }}
                                </td>
                                <td class="green-bold">
                                    {{ row.cumulativeSumOfPieces?.toLocaleString(appData.configuration.locale) }}
                                </td>
                                <td class="green-bold">
                                    {{ row.cumulativeSumOfAmounts?.toLocaleString(appData.configuration.locale) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </article>
            </div>

            <div v-if="chart" class="s-statistics__charts">
                <h3 class="s-statistics__charts__title">
                    <template v-if="activeResultsTab === 'cheques'">
                        {{ appData.dictionary.chartChequesTitle }}
                    </template>
                    <template v-if="activeResultsTab === 'unpaidBills'">
                        {{ appData.dictionary.chartUnpaidBillsTitle }}
                    </template>
                </h3>
                <div class="s-statistics__charts__items">
                    <div class="s-statistics__charts__item">
                        <div class="s-statistics__chart">
                            <line-chart
                                :key="chartUpdateKey"
                                :labels="chart.labels"
                                :datasets="chart.datasets"
                                :locale="appData.configuration.locale"
                                :is-amount="true"></line-chart>
                        </div>
                    </div>
                </div>
            </div>

            <div class="s-statistics__table">
                <article class="b-article">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <span>
                                        <template v-if="activeResultsTab === 'cheques'">
                                            {{ appData.dictionary.tableCheques }}
                                        </template>
                                        <template v-if="activeResultsTab === 'unpaidBills'">
                                            {{ appData.dictionary.tableUnpaidBills }}
                                        </template>
                                    </span>
                                </th>
                                <th>
                                    <span>{{ appData.dictionary?.tablePrevMonthPiecesDiff }}</span>
                                </th>
                                <th>
                                    <span>{{ appData.dictionary?.tablePrevMonthAmountsDiff }}</span>
                                </th>
                                <th>
                                    <span>
                                        {{ tablePrevYearPiecesDiff }}
                                    </span>
                                </th>
                                <th>
                                    <span>
                                        {{ tablePrevYearAmountsDiff }}
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, row_i) in activeResults" :key="'row-' + row_i">
                                <td>
                                    <strong>{{ appData.dictionary?.months[row.month] }}</strong>
                                </td>
                                <td>{{ row.prevMonthPiecesDiff?.toLocaleString(appData.configuration.locale) }}%</td>
                                <td>{{ row.prevMonthAmountsDiff?.toLocaleString(appData.configuration.locale) }}%</td>
                                <td>{{ row.prevYearPiecesDiff?.toLocaleString(appData.configuration.locale) }}%</td>
                                <td>{{ row.prevYearAmountsDiff?.toLocaleString(appData.configuration.locale) }}%</td>
                            </tr>
                        </tbody>
                    </table>
                </article>
            </div>
        </div>
    </div>
</template>

<script>
import * as lib from 'Root/lib/lib.js'
import statisticsMixins from 'Root/vue/mixins/statisticsMixins'
import LineChart from 'Root/vue/components/LineChart.vue'
import ScrollableTable from 'Root/ui/components/ScrollableTable.js'

export default {
    components: {
        LineChart,
    },

    mixins: [statisticsMixins],

    props: {
        results: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },

    emits: ['results-tab-clicked'],

    data() {
        return {
            resultsTabs: [],
            activeResultsTab: null,
            activeResults: null,

            chart: null,
            chartUpdateKey: 0,
        }
    },

    computed: {
        activeResultsYear() {
            return this.activeResults && this.activeResults.length ? this.activeResults[0].year : ''
        },
        tablePrevYearAmountsDiff() {
            return this.activeResults && this.activeResults.length
                ? `${this.appData.dictionary?.tablePrevYearDiff} ${this.activeResults[0].year}/${
                      this.activeResults[0].year - 1
                  } ${this.appData.dictionary?.tablePrevYearDiffAmounts}`
                : ''
        },
        tablePrevYearPiecesDiff() {
            return this.activeResults && this.activeResults.length
                ? `${this.appData.dictionary?.tablePrevYearDiff} ${this.activeResults[0].year}/${
                      this.activeResults[0].year - 1
                  } ${this.appData.dictionary?.tablePrevYearDiffPieces}`
                : ''
        },
    },

    mounted() {
        this.iniResultsTabs()

        if (this.resultsTabs.length) {
            this.setActiveResultsTab(this.resultsTabs[0].id)
        }

        document.querySelectorAll('.b-article table').forEach((elem) => {
            elem.ScrollableTable = new ScrollableTable(elem)
        })
    },

    methods: {
        iniResultsTabs() {
            if (this.results.cheques) {
                this.resultsTabs.push({
                    id: 'cheques',
                    text: `${this.appData.dictionary.chequesTabTitle} ${this.results.cheques[0].year}`,
                })
            }

            if (this.results.unpaidBills) {
                this.resultsTabs.push({
                    id: 'unpaidBills',
                    text: `${this.appData.dictionary.unpaidBillsTabTitle} ${this.results.unpaidBills[0].year}`,
                })
            }
        },

        resultsTabClicked(id) {
            this.setActiveResultsTab(id)
            this.$emit('results-tab-clicked')
        },

        setActiveResultsTab(id) {
            this.activeResultsTab = id
            this.activeResults = this.results[id]

            this.iniChartData()

            this.chartUpdateKey++
        },

        iniChartData() {
            const labels = this.createChartFullYearMonthsLabels(this.activeResults)
            const piecesData = []
            const amountsData = []

            labels.forEach((label, index) => {
                const monthResultsItem = this.activeResults.find((i) => i.month === index + 1)

                if (lib.hasValue(monthResultsItem)) {
                    piecesData.push(monthResultsItem.pieces)
                    amountsData.push(monthResultsItem.amounts)
                } else {
                    piecesData.push(null)
                    amountsData.push(null)
                }
            })

            this.chart = {
                labels: ['', ...labels, ''],
                datasets: [
                    {
                        label: this.appData.dictionary.chartPieces,
                        data: [null, ...piecesData, null],
                        yAxisMin: 0,
                        yAxisMax: 1000,
                    },
                    {
                        label: this.appData.dictionary.chartAmounts,
                        data: [null, ...amountsData, null],
                        yAxisID: 'rightY',
                        yAxisMin: 0,
                        yAxisMax: 30000000,
                    },
                ],
            }
        },
    },
}
</script>
